<template>
  <LoginCard :showCustomLogo="false">
    <svg viewBox="0 0 201 33" fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.logo" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M56.598 20.364a7.584 7.584 0 01-7.584 7.584H46.93c-.217-2.528-2.825-4.678-6.513-5.676a6.585 6.585 0 10-9.25 0 11.458 11.458 0 00-4.758 2.415 11.465 11.465 0 00-2.76-1.135 5.635 5.635 0 10-7.89 0c-2.907.805-5.024 2.415-5.475 4.364H8.198a7.592 7.592 0 010-15.176c.965.003 1.921.19 2.818.548a7.568 7.568 0 016.915-4.404h.548a9.886 9.886 0 0118.178-3.22 8.05 8.05 0 0110.385 7.406 7.568 7.568 0 019.556 7.326v-.032zm10.466 6.795V14.278h-3.937v13.436c0 .902-.29 1.506-1.183 1.506a4.455 4.455 0 01-.926-.089l-.177 3.39c.42.069.846.11 1.272.12 3.655-.032 4.983-2.15 4.983-5.482h-.032zm11.705.805h3.849v-13.75h-3.913v7.647a2.65 2.65 0 01-2.721 2.923c-1.45 0-2.085-.95-2.085-2.375v-8.196h-3.937v9.299c0 2.987 1.337 4.83 3.937 4.83 2.174 0 3.856-1.393 4.637-4.025h.29l-.057 3.647zm10.57-7.648a2.673 2.673 0 012.754-2.898c1.417 0 2.085.957 2.085 2.35v8.196h3.937v-7.648a2.647 2.647 0 012.721-2.898c1.449 0 2.085.957 2.085 2.35v8.196h3.969v-9.315c0-2.987-1.36-4.83-4.025-4.83-2.262 0-3.824 1.417-4.573 4.106h-.322c-.169-2.577-1.36-4.106-3.792-4.106-2.173 0-3.824 1.385-4.605 4.025h-.29v-3.679h-3.848V27.9h3.937l-.032-7.583zm33.596.805c0-4.726-1.715-7.246-4.726-7.246-2.198 0-3.703 1.45-4.428 3.848h-.257v-3.477h-3.945v18.13h3.945V24.38h.225c.701 2.415 2.174 4.026 4.46 4.026 2.987-.057 4.774-2.577 4.774-7.294l-.048.008zm-6.634 3.76c-1.682 0-2.777-1.273-2.777-3.22v-1.08c0-1.964 1.071-3.22 2.809-3.22 1.876 0 2.722 1.192 2.722 3.712 0 2.52-.814 3.8-2.722 3.8l-.032.007zm17.784-5.064l3.647-.7c-.491-3.326-2.23-5.266-6.312-5.266-4.371 0-7.036 2.745-7.036 7.415 0 4.669 2.721 7.092 7.06 7.092 3.913 0 5.853-1.996 6.32-5.184l-3.623-.87c-.29 1.417-.958 2.609-2.721 2.609-2.029 0-3.011-1.417-3.011-3.857 0-2.6 1.127-3.76 2.955-3.76 1.827 0 2.407 1.031 2.753 2.512l-.032.009zm9.87-10.466h-3.905v18.597h3.937l-.032-18.597zm9.274 19c4.372 0 7.036-2.754 7.036-7.246 0-4.493-2.753-7.246-7.036-7.246-4.283 0-7.1 2.665-7.1 7.246 0 4.58 2.672 7.245 7.132 7.245h-.032zm0-11.207c2.174 0 3.124 1.417 3.124 3.904 0 2.488-.926 3.945-3.124 3.945s-3.131-1.449-3.131-3.945c0-2.495.958-3.904 3.131-3.904zm17.985 10.804h3.848V14.213h-3.96v7.648a2.658 2.658 0 01-2.73 2.923c-1.441 0-2.085-.95-2.085-2.375v-8.196h-3.936v9.299c0 2.987 1.336 4.83 3.936 4.83 2.174 0 3.856-1.393 4.637-4.025h.29v3.63zm15.377 0h3.937V9.35h-3.945v8.34h-.258c-.724-2.415-2.206-3.848-4.404-3.848-3.01 0-4.749 2.576-4.749 7.35 0 4.637 1.739 7.157 4.693 7.157 2.287 0 3.792-1.61 4.484-4.025h.234l.008 3.623zm-2.778-3.076c-1.94 0-2.785-1.215-2.785-3.679 0-2.463.869-3.792 2.753-3.792 1.739 0 2.81 1.272 2.81 3.277v1.087c-.008 1.892-1.127 3.107-2.778 3.107zM67.257 10.382a2.126 2.126 0 11-4.251 0 2.126 2.126 0 014.251 0z" fill="#002B49"/></svg>
    <h1 :class="$style.header">
      Administrator Login
    </h1>
    <EmailBadge
      :email="userLoginStore.email"
    >
      <template
        slot="badgeAction"
      >
        <button
          :class="$style.actionLink"
          @click="handleResetEmail"
          data-test-id="badgeActionButton"
        >
          {{ loginLabels.changeEmail }}
        </button>
      </template>
    </EmailBadge>
    <LoginAlert
      v-if="alertMessage"
      centered
      :class="$style.alertMarginBottom"
      :message="alertMessage"
    >
      <div>
        {{ alertMessage }}
        <div v-if="showInvalidCredentialsError">
          <div>
            {{ loginLabels.invalidCredentials }}
          </div>
          <div>
            <span>Are you trying to </span>
            <a
              :class="$style.swapClientTypeLink"
              @click="goToUserLogin"
            >
              log in as a User?
            </a>
          </div>
        </div>
      </div>
    </LoginAlert>
    <form
      autocomplete="on"
      :action="authURL"
      method="post"
    >
      <input
        data-test-id="email-input"
        :class="$style.hiddenEmail"
        readonly
        type="email"
        :value="userLoginStore.email"
      >
      <div :class="$style.passwordFieldContainer">
        <LoginTextField
          autoFocus
          :autocomplete="false"
          @focus="updateAutofocus('password')"
          label="Password"
          name="password"
          placeholder="Administrator Password"
          value=""
          :submitOnEnter="submit"
          :rules="{ max: 64, required: true }"
          vvName="password"
          :type="inputType"
          v-model="userLoginStore.password"
        />
        <IconButton
          :class="$style.passwordVisibilityToggle"
          :icon="icon"
          :ariaLabel="loginLabels.togglePasswordVisibility"
          @click="togglePasswordVisibility"
        />
      </div>
      <LoginActionButton
        :action="submit"
        data-automation="loginButton"
        :isLoading="isLoading"
        type="submit"
      >
        Admin Login
      </LoginActionButton>
    </form>
    <div :class="$style.resetPassword">
      <span
        :class="$style.resetPasswordLink"
        @click="redirect(resetPasswordRoute)"
      >
        Reset Administrator Password
      </span>
    </div>
  </LoginCard>
</template>
<script>
import { AdminRoutes } from 'client/routes/RouteGenerator';
import { get } from 'lodash';
import { mapGetters } from 'vuex';
import { mapStores } from 'pinia';

import AdminLoginApi from 'client/api/AdminLoginApi';
import Constants, { XhrConsts } from 'client/util/Constants';
import EmailBadge from 'client/components/EmailBadge.vue';
import IconButton from 'client/components/IconButton.vue';
import LocalStorageConstants from 'client/util/Constants/LocalStorageConstants';
import LocalStorageService from 'client/util/LocalStorageService';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginAlert from 'client/components/LoginAlert.vue';
import LoginCard from 'client/components/LoginCard.vue';
import LoginConsts from 'client/util/Constants/LoginConstants';
import LoginTextField from 'client/components/LoginTextField.vue';
import UserLoginStore from 'client/stores/UserLoginStore';
import Util from 'client/util/Util';
import api from 'client/api';
import autoFillCredentialsFix from 'client/components/mixins/autoFillCredentialsFix';
import loginUtil from 'client/components/mixins/loginUtil';

import { useLoginLabels } from 'client/util/Constants/LoginLabels';

const { redirectTo } = Constants;
const {
  invalidCsrf,
  loginError,
  mfaRequired,
} = LoginConsts.responseMessages;
const { authURLs } = LoginConsts;
const { error } = LoginConsts.alertTypes;
const { admin } = LoginConsts.clientType;

const {
  dashboard, resetPassword, verifyMFA,
} = AdminRoutes;

const { localStorageOrgKey } = LocalStorageConstants;
const { xOrgIdHeader } = XhrConsts;

export default {
  name: 'AdminPasswordEntry',

  mixins: [loginUtil, autoFillCredentialsFix],

  props: {
    clientType: {
      type: String,
      default: admin,
    },
  },

  components: {
    EmailBadge,
    IconButton,
    LoginAlert,
    LoginActionButton,
    LoginCard,
    LoginTextField,
  },

  data: () => ({
    alertMessage: '',
    alertType: '',
    authURL: authURLs[admin],
    invalidCsrfMessage: 'Invalid CSRF token. Please refresh the page and try again.',
    loginError,
    isPasswordVisible: false,
    passwordTimer: undefined,
  }),

  computed: {
    ...mapStores(UserLoginStore),

    resetPasswordRoute: () => resetPassword,
    ...mapGetters('LoginOauthAdminFlowModel', [
      'loginChallenge',
    ]),

    showInvalidCredentialsError() {
      return this.alertMessage === loginError;
    },

    inputType() {
      return this.isPasswordVisible ? 'text' : 'password';
    },

    icon() {
      return this.isPasswordVisible ? 'viewableOff' : 'viewable';
    },
  },
  setup() {
    const loginLabels = useLoginLabels();

    return {
      loginLabels,
    };
  },
  methods: {
    goToUserLogin() {
      // removing redirectTo from session to prevent issues when swtiching clientTypes
      sessionStorage.removeItem(redirectTo);
      this.vueRouteChange('Login', { form: { email: this.userLoginStore.email, password: this.userLoginStore.password } });
    },

    handleResetEmail() {
      this.$emit('changeStep');
    },

    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
      clearTimeout(this.passwordTimer);
      this.passwordTimer = setTimeout(() => {
        this.isPasswordVisible = false;
      }, 4000);
    },

    /**
     * handles the catch for the login request
     * @param  {Object} err result from the axios request
     * @return {String}     where we redirected the user or the resulting error
     */
    handleError(err) {
      const { response } = err;
      let alertMessage = loginError;

      if (response?.data?.message) {
        const { message } = response.data;

        if (message === mfaRequired) {
          this.redirect(`${verifyMFA}${this.loginChallenge ? `&login_challenge=${this.loginChallenge}` : ''}`);
          return verifyMFA;
        }

        if (message === invalidCsrf) {
          alertMessage = this.invalidCsrfMessage;
        } else {
          alertMessage = message;
        }
      }

      this.setAlertMessage(error, alertMessage);

      return alertMessage;
    },

    /**
     * handle success function for login request
     * @return {Promise} [Promise that resolves to which url the user will redirect to]
     */
    async handleSuccess(resp) {
      const organizationId = resp?.headers[xOrgIdHeader.toLowerCase()];
      if (organizationId) LocalStorageService.setItem(localStorageOrgKey, organizationId);
      if (this.loginChallenge) {
        try {
          const { data: { redirect_to: oidcRedirect } } = await AdminLoginApi
            .completeLoginChallengeOIDC(this.loginChallenge);
          Util.redirect(oidcRedirect);
          return new Promise(() => {});
        } catch (_) {
          return this.$router.push(this.oidc.error);
        }
      }

      const lastUrl = get(resp, 'data.lastUrl', dashboard);

      return this.redirect(lastUrl);
    },

    // called from loginUtil submit
    request() {
      this.isLoading = true;
      const { handleSuccess, handleError } = this;
      return api.admin.login(this.getCredentialsPayload())
        .then(handleSuccess)
        .catch(handleError)
        .finally(() => {
          this.isLoading = false;
        });
    },

    /**
     * Sets the two data properties the Alert component uses to display successes & errors
     * @param {[type]} alertType    [determines the color of the alert]
     * @param {[type]} alertMessage [what the error message will display]
     */
    setAlertMessage(alertType, alertMessage) {
      this.alertType = alertType;
      this.alertMessage = alertMessage;
    },

    /**
     * @Override the setRequestState function from the loginUtil mixin
     */
    setRequestState() {
      this.alertType = '';
      this.alertMessage = '';
      this.isLoading = true;
    },

    /**
     * @return {Object} [returns the promise returned from the validation]
     */
    validate() {
      const { formComponent } = this.$refs;
      const component = formComponent || this;
      return component.$validator.validateAll();
    },
  },
};
</script>
<style module>
@import '../../../css/login-components.css';

@value (jcInformational900) from 'css/brand-colors.css';

.actionLink {
  background-color: transparent;
  border: none;
  color: jcInformational900;
  cursor: pointer;
  margin-left: 1em;
  padding: 0;
  text-decoration: none;
}

.alertMarginBottom {
  margin-bottom: 1.5rem;
  margin-top: 0;
}

.hiddenEmail {
  display: none;
}

.passwordFieldContainer {
  align-items: flex-end;
  display: flex;
  gap: 0.5rem;
}

.passwordVisibilityToggle {
  margin-bottom: 1.5rem;
}
</style>
